// DS: CO1.3
import React from 'react';
import c from 'classnames';
import { PapiBadge } from '@wix/da-papi-types';
import Badge from '@wix/da-ds/pkg/Badge';

import s from './SpotlightBadge.scss';

export interface Props {
  className?: string;
  badge: PapiBadge;
}

const SpotlightBadge: React.FC<Props> = ({ className, badge }) => {
  return (
    <div className={c(s['root'], className)}>
      <Badge className={s['badge']} badge={badge} size={68} type="huge" />
      <div className={s['blur']} />
      <div className={s['title']}>{badge.baseTitle}</div>
    </div>
  );
};
SpotlightBadge.displayName = 'SpotlightBadge';

export default SpotlightBadge;
